import React, { FC, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { IonPage } from '@ionic/react'
import { memberMobx } from '@mobxStore'
import MemberApi from '@api/member.api'
import './index.scss'
interface IProps {
  match: any;
}

const WechatCoupon: FC<IProps> = ({ match }: IProps) => {
  const [info, setInfo] = useState<any>(null)
  useEffect(() => {
    MemberApi.getWxAppInfo().then((res: any) => {
      if (res.result) {
        setInfo(res.result)
      }
    })
  }, [])
  return (
    <IonPage>
      <div className='jumm-wx-page'>
        <div className='head-info'>
          {
            info &&
              <>
                <div className='logo'>
                  <img src={info.headImg} alt='' />
                </div>
                <div className='name'>{info.nickName}</div>
              </>
          }
          <div className='des'>
            <i className='iconfont icon-miniapp'></i>
            <span>小程序</span>
          </div>
        </div>
        <div
          className='jump-bth' onClick={() => {
            if (localStorage.getItem(memberMobx.miniOpenLinkKey)) {
              location.href = localStorage.getItem(memberMobx.miniOpenLinkKey)
            }
          }}
        >前往微信打开
        </div>
      </div>
    </IonPage>
  )
}

export default observer(WechatCoupon)
